import { VertiNodeLocale, type VertiNodeLocalizedString } from "../VertiNodeLocale.js";

export const vertiNodeReferencesPathMap = {
	[VertiNodeLocale.cs]: "reference",
	[VertiNodeLocale.en]: "references",
} satisfies VertiNodeLocalizedString;
